// ##### 23-03-20 Komarov: Функционал для определения ширины полосы прокрутки
// создадим элемент с прокруткой
// ##### Komarov 2025-07-25

import { isServer } from '../../../../server/helpers/browserDetector';

let scrollWidth = 0;

if (!isServer) {
  const div = document.createElement('div');
  div.style.overflowY = 'scroll';
  div.style.width = '50px';
  div.style.height = '50px';
  // мы должны вставить элемент в документ, иначе размеры будут равны 0
  document.body.append(div);
  scrollWidth = div.offsetWidth - div.clientWidth;
  div.remove();
}

export { scrollWidth };
